export enum WITHHOLDING_TAX_TYPE {
  CUSTOMER_PAYMENT = '101',
  EXPANDED_VAT_TO_GOVERNMENT = '111'
};
